import { render } from "./KarussellFeiern1.vue?vue&type=template&id=7ba2c002"
import script from "./KarussellFeiern1.vue?vue&type=script&lang=js"
export * from "./KarussellFeiern1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__